module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bigDiv"
  }, [_c('div', {
    staticClass: "head"
  }, [_c('div', {
    staticClass: "avatar"
  }, [_c('x-img', {
    attrs: {
      "default-src": "",
      "src": ""
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "user"
  }, [_c('span', [_vm._v(_vm._s(_vm.userName))]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": ".3rem",
      "color": "#A8B0C6"
    }
  }, [_vm._v(_vm._s(_vm.className)), (_vm.className != '') ? _c('span', [_vm._v("|")]) : _vm._e(), _vm._v(_vm._s(_vm.releaseTime))])]), _vm._v(" "), (_vm.subFlag) ? _c('div', {
    staticClass: "subject"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/icon001.png")
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.subName))])]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-183574cf"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/share/dynamicShare.vue
// module id = 441
// module chunks = 1